import PropTypes from 'prop-types';
import { useState } from 'react';
import styles from './SelecaoLojaPage.module.css';

const CANAL_LABEL = {
  IMOB: 'IMOB',
  4004: '4004',
  Virtual: 'Virtual',
  Físico: 'Físico',
};

const normalizarChave = str =>
  str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s/g, '');

const normalizarBusca = str =>
  str
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

function SelecaoLojaPage({ lojas = [], onSelect }) {
  const [busca, setBusca] = useState('');
  const [selecionando, setSelecionando] = useState(null);

  const email = lojas[0]?.email ?? '';

  const buscaNormalizada = normalizarBusca(busca);

  const lojasFiltradas = lojas.filter(
    loja =>
      normalizarBusca(loja.nome ?? '').includes(buscaNormalizada) ||
      normalizarBusca(loja.tipoCanal ?? '').includes(buscaNormalizada) ||
      normalizarBusca(loja.tipoPrestacao ?? '').includes(buscaNormalizada)
  );

  const handleSelect = loja => {
    setSelecionando(loja.idLoja);
    onSelect(loja.jwt);
  };

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <img src="img/logo_mrv.webp" alt="MRV" className={styles.logo} />
        <h1 className={styles.titulo}>Simulador de Crédito</h1>
      </div>

      <div className={styles.container}>
        <div className={styles.intro}>
          <h2 className={styles.subtitulo}>Selecione sua loja</h2>
          {email && (
            <p className={styles.emailUsuario}>
              Olá, <strong>{email}</strong>. Escolha a loja para iniciar a simulação.
            </p>
          )}
        </div>

        <div className={styles.buscaWrapper}>
          <input
            type="text"
            placeholder="Buscar por nome, canal ou prestação..."
            className={styles.busca}
            value={busca}
            onChange={e => setBusca(e.target.value)}
          />
        </div>

        {lojasFiltradas.length === 0 ? (
          <p className={styles.semResultados}>Nenhuma loja encontrada.</p>
        ) : (
          <div className={styles.grid}>
            {lojasFiltradas.map(loja => {
              const canalKey = `canal${normalizarChave(loja.tipoCanal ?? 'default')}`;
              const prestacaoKey = `prestacao${normalizarChave(loja.tipoPrestacao ?? 'default')}`;
              return (
                <button
                  key={loja.idLoja ?? loja.jwt}
                  className={`${styles.card} ${selecionando === loja.idLoja ? styles.cardSelecionando : ''}`}
                  onClick={() => handleSelect(loja)}
                  disabled={selecionando !== null}
                >
                  <span className={styles.nomeLoja}>{loja.nome ?? '—'}</span>
                  <div className={styles.badges}>
                    <span className={`${styles.badge} ${styles[canalKey]}`}>
                      {CANAL_LABEL[loja.tipoCanal] ?? loja.tipoCanal ?? '—'}
                    </span>
                    <span className={`${styles.badge} ${styles[prestacaoKey]}`}>
                      {loja.tipoPrestacao ?? '—'}
                    </span>
                  </div>
                </button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

SelecaoLojaPage.propTypes = {
  lojas: PropTypes.arrayOf(
    PropTypes.shape({
      jwt: PropTypes.string.isRequired,
      nome: PropTypes.string,
      tipoCanal: PropTypes.string,
      tipoPrestacao: PropTypes.string,
      idLoja: PropTypes.string,
      idCidade: PropTypes.string,
      email: PropTypes.string,
    })
  ),
  onSelect: PropTypes.func.isRequired,
};

export default SelecaoLojaPage;
